// A small pill-style card used to show a device name (and optional
// version/sub-label) inside device-mismatch dialogs.
export default function DeviceChip({ label, value, subValue, highlight }) {
    return (
        <div
            style={{
                flex: 1,
                minWidth: 0,
                textAlign: 'center',
                padding: '0.75rem 0.5rem',
                borderRadius: '1.2rem',
                background: highlight
                    ? 'linear-gradient(135deg, #fff1ea, #ffe1d4)'
                    : '#f4f2f1',
                border: highlight ? '1px solid #f9c9b3' : '1px solid #e7e4e3',
            }}
        >
            <div
                style={{
                    fontSize: '1.2vh',
                    letterSpacing: '0.04em',
                    textTransform: 'uppercase',
                    color: highlight ? '#f97d62' : '#999',
                    fontWeight: 700,
                    marginBottom: '0.25rem',
                }}
            >
                {label}
            </div>
            <div
                style={{
                    fontSize: '1.9vh',
                    fontWeight: 700,
                    color: '#333',
                    wordBreak: 'break-word',
                }}
            >
                {value}
            </div>
            {subValue && (
                <div
                    style={{
                        fontSize: '1.5vh',
                        color: '#888',
                        marginTop: '0.15rem',
                    }}
                >
                    v{subValue}
                </div>
            )}
        </div>
    )
}
